const SpinnerTiny = () => {
  return (
    <div className="w-[1.2em] h-[1.2em] bg-gradient-to-b from-[#94a4fd] to-[#282929]  rounded-full relative rotate">
      <div className="w-2/3 h-2/3 bg-[#1c1c1c] rounded-full absolute top-[50%] left-[50%] translate-x-[-50%] translate-y-[-50%]"></div>
    </div>
  );
};

export default SpinnerTiny;
